var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"fot_nav"}),_c('div',{staticClass:"fot_text"},[_vm._v("Copyright China Electronic Components Association. 中国电子元件行业协会 All rights reserved")])])
}]

export { render, staticRenderFns }